import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { interviewNumbering, learningAjahnNumbering } from '../../utils/constant';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import { interviewFormValidationSchema } from '../../utils/formValidation';
import { postInterviewForm } from '../../services/interview';
import { errorToast } from '../../utils/errorHandling';
import { toast } from 'react-toastify';
import useFormValidation from '../../hooks/useFormValidation';
import { AiOutlineLoading } from 'react-icons/ai';
import { getActiveCourseAjahn } from '../../services/settings';
import SubmissionConfirmationPage from '../../components/SubmissionConfirmationPage';

const base_url = process.env.REACT_APP_BASE_URL;

const CreateInterview = () => {
    const { t } = useTranslation();
    const [interviewAjahnsList, setInterviewAjahnsList] = useState([]);
    const [learningAjahnsList, setLearningAjahnsList] = useState([]);
    const [courseData, setCourseData] = useState(
        localStorage.getItem("courseData")
            ? JSON.parse(localStorage.getItem("courseData"))
            : null
    );
    const lang = localStorage.getItem("i18nextLng");
    const [inPersonAjahnsList, setInPersonAjahnsList] = useState([]);
    const [onlineAjahnsList, setOnlineAjahnsList] = useState([]);
    const [selectedAjahn, setSelectedAjahn] = useState(Array(interviewNumbering(t).length).fill(""));
    const [selectedLearningAjahn, setSelectedLearningAjahn] = useState(Array(learningAjahnNumbering(t).length).fill(""));
    const [formSection, setFormSection] = useState(1);
    const [formPercentage, setFormPercentage] = useState("33%");
    const [formData, setFormData] = useState({});
    const [formValidationSchema, setFormValidationSchema] = useState([]);
    const [role, setRole] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(interviewFormValidationSchema(t));
    const navigate = useNavigate();
    const interviewKeys = interviewNumbering(t).map(item => item.key);
    const learningKeys = learningAjahnNumbering(t).map(item => item.key);

    const navigateFormSection = (forward) => {
        if (formSection === 2 && forward) {
            if (validateAllFields(formData, formValidationSchema)) {
                const section = forward ? formSection + 1 : formSection - 1;
                setFormSection(section);
                const percentage = (section / 3) * 100;
                const percentageString = percentage + "%";
                setFormPercentage(percentageString);
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                toast.error(t("general.ValidationFail"));
            }
        } else {
            const section = forward ? formSection + 1 : formSection - 1;
            setFormSection(section);
            const percentage = (section / 3) * 100;
            const percentageString = percentage + "%";
            setFormPercentage(percentageString)
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [formSection]);

    const fetchAjahn = async () => {
        try {
            setIsLoading(true);
            const response = await getActiveCourseAjahn();
            if (response.length > 0) {
                setLearningAjahnsList(response.filter(e => e.is_learning == 1));
                setInterviewAjahnsList(response.filter(e => e.is_interview == 1));
                setInPersonAjahnsList(response.filter(e => e.mode === "In-person"));
                setOnlineAjahnsList(response.filter(e => e.mode === "Online"));
                const initialFormData = {
                    is_interview: "",
                    ...Object.fromEntries(
                        interviewKeys.map(key => [key, ""])
                    ),
                    ...Object.fromEntries(
                        learningKeys.map(key => [key, ""])
                    ),
                };

                setFormData(initialFormData)
                setFormValidationSchema([
                    "is_interview",
                ]);
                setRole(localStorage.getItem("retreat_language") ? JSON.parse(localStorage.getItem("retreat_language")) : "");
            }
            return true;
        } catch (error) {
            errorToast(error, t('general.ActionFailed'), t)
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchAjahn();
    }, [])

    const handleAjahnSelectionChange = (index, event) => {
        const { id, value } = event.target;
        const newSelectedAjahn = [...selectedAjahn];
        newSelectedAjahn[index] = value;
        setSelectedAjahn(newSelectedAjahn);
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value);
    };
    const getAvailableAjahnOptions = (currentIndex) => {
        const alreadySelected = selectedAjahn.filter((_, idx) => idx !== currentIndex);
        return interviewAjahnsList.filter(option => !alreadySelected.includes(option.ajahn_ename));
    };

    const handleAjahnLearningSelectionChange = (index, event) => {
        const { id, value } = event.target;
        const newSelectedLearningAjahn = [...selectedLearningAjahn];
        newSelectedLearningAjahn[index] = value;
        setSelectedLearningAjahn(newSelectedLearningAjahn);
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value);
    };
    const getAvailableLearningAjahnOptions = (currentIndex) => {
        const alreadySelected = selectedLearningAjahn.filter((_, idx) => idx !== currentIndex);
        return learningAjahnsList.filter(option => !alreadySelected.includes(option.ajahn_ename));
    };

    const handleInputChange = (e) => {
        const { id, name } = e.target;
        if (name === "is_interview") {
            setFormData((prevState) => ({
                ...prevState,
                [name]: id,
            }));
            if ((role === "Chinese" || role === "Thai") && id === "1") {
                const formValidationData = [
                    "is_interview",
                    ...interviewKeys,
                    ...learningKeys
                ];
                setFormValidationSchema(formValidationData);
            } else if ((role === "Chinese" || role === "Thai") && id === "0") {
                setFormValidationSchema([
                    "is_interview",
                    ...learningKeys
                ]);
            } else if (role === "English" && id === "1") {
                setFormValidationSchema([
                    "is_interview",
                    ...interviewKeys,
                ]);
            } else if (role === "English" && id === "0") {
                setFormValidationSchema([
                    "is_interview"
                ]);
            }
            validateField(name, id);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const submitInterviewForm = async () => {
            try {
                const data = await postInterviewForm(formData);
                if (data) {
                    toast.success(t("interview.InterviewSuccess"));
                    navigate(`${base_url}/view-interview`);
                }
            } catch (error) {
                errorToast(error, t("Passport.SubmitedFailed"), t);
            } finally {
                setIsSubmitting(false);
            }
        }
        setIsSubmitting(true);
        if (validateAllFields(formData, formValidationSchema)) {
            submitInterviewForm();
        } else {
            toast.error(t("personal_info.ValidateFailedfield"));
            setIsSubmitting(false);
        }
    }
    return (
        <>
            {
                learningAjahnsList.length <= 0 || interviewAjahnsList.length <= 0 ?
                    <div className='info-container'>
                        <h3>{t("interview.BigTitle")}</h3>
                        <p>
                            {
                                lang === "en" ?
                                    courseData.course_ename
                                    :
                                    courseData.course_cname
                            }
                        </p>
                        {isLoading ?
                            <>
                                <AiOutlineLoading className='spin' />
                                <p>{t("interview.Loadinginterview")}</p>
                            </>
                            :
                            <>
                                <p style={{ "color": "#ff0000" }}>{t("personal_info.msg_admin")}</p>
                                <div className='action-buttons'>
                                    <Link to={`${process.env.REACT_APP_CUSTOMER_SERVICE_LINK}${JSON.parse(localStorage.getItem("token"))}`} target="_blank" rel="noopener noreferrer">
                                        <Button
                                            buttonStyle='btn--primary'
                                            buttonSize='btn--small'
                                        >{t("personal_info.contact_admin")}</Button>
                                    </Link>

                                </div>
                            </>
                        }

                    </div>
                    :
                    <>
                        <div className='info-container'>
                            <h3>{t("interview.BigTitle")}</h3>
                            <p>
                                {
                                    lang === "en" ?
                                        courseData.course_ename
                                        :
                                        courseData.course_cname
                                }
                            </p>
                            <div className='action-buttons'>
                                <Link to={`${base_url}/view-interview`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("ctransportation.cancel")}</Button>
                                </Link>
                            </div>
                        </div>
                        <div className='form-wrapper'>
                            <h4 className='d-flex mt-3 justify-content-left'>{t("general.Page")} {formSection} {t("general.OF3")}</h4>
                            <div className="progress mb-5">
                                <div className="progress-bar bg-success" role="progressbar" style={{ "width": formPercentage }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <form>
                                <div className='form-section-1' hidden={formSection !== 1}>
                                    <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.NOTICE")}</strong></span></p>
                                    <ul>
                                        {/* <li>{t("interview.N1")}</li> */}
                                        <li>{t("interview.N2")}</li>
                                    </ul>
                                    <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.studentNO")}</strong></span></p>
                                    <ol>
                                        <li>{t("interview.SN1")}</li>
                                        <li>{t("interview.SN2")}</li>
                                        {/* <li>{t("interview.SN3")}</li> */}
                                        <li>{t("interview.SN4")} <br />
                                            {t("interview.SN5")}</li>
                                        <li>{t("interview.SN6")}</li>
                                    </ol>
                                    <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.NonInt_STU")}</strong></span></p>
                                    <ol>
                                        <li>{t("interview.NIS_1")}</li>
                                        <li>{t("interview.NIS_2")}</li>
                                        <li>{t("interview.NIS_4")} <br />
                                            {t("interview.NIS_5")}</li>
                                    </ol>
                                    <p><span style={{ "color": "#ff0000" }}><strong>⛳️{t("interview.Stu_Req_Eng")}</strong></span></p>
                                    <ol>
                                        <li>{t("interview.SRE1")}</li>
                                        <li>{t("interview.SRE2")}</li>
                                    </ol>
                                    <p>
                                        <span style={{ "color": "#ff0000" }}>{t("interview.SRE3")}</span>
                                    </p>

                                </div>
                                <div className='form-section-2' hidden={formSection !== 2}>
                                    <div className='section-title'>
                                        <h4 className='mb-0'>{t("interview.Int_INFO")}</h4>
                                    </div>
                                    <p className='mt-3'><strong>{t("interview.desOPT")}</strong></p>
                                    <ul className='mb-0'>
                                        <li>{t("interview.FC1")}</li>
                                        <li>{t("interview.FC2")}</li>
                                        <li>{t("interview.FC3")}</li>
                                        <li>{t("interview.FC4")}</li>
                                        <li>{t("interview.FC5")}</li>
                                    </ul>
                                    <p><span style={{ "color": "#ff0000" }}>{t("interview.fc", {interview_ajahn_quantity: interviewAjahnsList.length})}</span></p>
                                    <p className='mt-3'><strong>{t("interview.Int_QUO")}</strong></p>
                                    <ol>
                                        {interviewAjahnsList.map((i, index) => (
                                            <li key={index}>
                                                {localStorage.getItem("i18nextLng") === 'en' ? i.ajahn_ename : i.ajahn_cname}
                                                &nbsp;:&nbsp;
                                                <span style={{ "fontStyle": "italic" }}>{i.interview_pax} {t("Constant.PAX")}</span>
                                            </li>
                                        ))}
                                    </ol>
                                    {role !== "English" &&
                                        <>
                                            <label>{t("interview.selectLearningAjahn")}</label>
                                            {errors && Object.entries(errors).map(([key, error]) => {
                                                if (key !== "is_interview" && error !== "" && !interviewKeys.includes(key)) {
                                                    return <p className='m-0'><span key={key} className="error">{error}</span></p>;
                                                }
                                            })}
                                            <table className="table table-light" style={{ "fontSize": "13px", maxWidth: "800px" }}>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">{t("interview.choice")}</th>
                                                        <th scope="col">{t("interview.learningAjahn")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {learningAjahnNumbering(t).map((i, index) => (
                                                        <tr key={index}>
                                                            <td>{i.displayNumbering}</td>
                                                            <td>
                                                                <select
                                                                    id={i.key}
                                                                    value={selectedLearningAjahn[index] || ""}
                                                                    onChange={(e) => handleAjahnLearningSelectionChange(index, e)}
                                                                >
                                                                    <option value="">{t("interview.s2")}</option>
                                                                    {getAvailableLearningAjahnOptions(index).map((option, idx) => (
                                                                        <option key={idx} value={option.ajahn_ename}>
                                                                            {localStorage.getItem("i18nextLng") === 'en' ? option.ajahn_ename : option.ajahn_cname}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    ))
                                                    }

                                                </tbody>
                                            </table>
                                        </>
                                    }
                                    <div className="form-item">
                                        <label>{t("interview.q1")}
                                            <span style={{ "color": "#ff0000" }}>{t("interview.interviewNonEditable")}</span></label>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="is_interview" id="1" required
                                                onChange={handleInputChange} />
                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                        </div>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="is_interview" id="0" required
                                                onChange={handleInputChange} />
                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                        </div>
                                    </div>
                                    {errors.is_interview && <span className="error">{errors.is_interview}</span>}
                                    {formData.is_interview === "1" && (
                                        <>
                                            <label>{t("interview.selectInterviewAjahn")}</label>
                                            {errors && Object.entries(errors).map(([key, error]) => {
                                                if (key !== "is_interview" && error !== "" && interviewKeys.includes(key)) {
                                                    return <p className='m-0'><span key={key} className="error">{error}</span></p>;
                                                }
                                            })}
                                            <div>
                                                <table className="table table-light" style={{ "fontSize": "13px", "maxWidth": "800px" }}>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">{t("interview.choice")}</th>
                                                            <th scope="col">{t("interview.interviewAjahn")}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {interviewNumbering(t).map((i, index) => (
                                                            <tr key={index}>
                                                                <td>{i.displayNumbering}</td>
                                                                <td>
                                                                    <select
                                                                        id={i.key}
                                                                        value={selectedAjahn[index] || ""}
                                                                        onChange={(e) => handleAjahnSelectionChange(index, e)}
                                                                    >
                                                                        <option value="">{t("interview.s2")}</option>
                                                                        {getAvailableAjahnOptions(index).map((option, idx) => (
                                                                            <option key={idx} value={option.ajahn_ename}>
                                                                                {localStorage.getItem("i18nextLng") === 'en' ? option.ajahn_ename : option.ajahn_cname}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                        </>
                                    )}
                                </div>
                                <div className='form-section-3' hidden={formSection !== 3}>
                                    <SubmissionConfirmationPage />
                                </div>
                                <div className='button-container mt-3'>
                                    <Button buttonStyle="btn--primary" hidden={formSection === 1} type="button" onClick={() => navigateFormSection(false)}>{t("general.BTNprevious")}</Button>
                                    <Button buttonStyle="btn--primary" hidden={formSection === 3} type="button" onClick={() => navigateFormSection(true)}>{t("general.BTNnext")}</Button>
                                    <Button buttonStyle="btn--primary" hidden={formSection !== 3} onClick={handleSubmit} disabled={isSubmitting}>
                                        {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                                    </Button>
                                </div>

                            </form>
                        </div>
                    </>
            }
        </>
    )
}

export default CreateInterview